module.exports = __webpack_public_path__ + "static/social-media-container-e3c662eb0ef0252c38abeecf0ae5b045.svg";